const s = {
  name: "Bus2",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,20v-2H15v2H25z"/>
		<path class="st0" d="M35.9,26H37c1.7,0,3-1.3,3-3V6c0-3.3-2.7-6-6-6H6C2.7,0,0,2.7,0,6v17c0,1.7,1.3,3,3,3h1.1
			c0.5,2.3,2.5,4,4.9,4c2.4,0,4.4-1.7,4.9-4h12.2c0.5,2.3,2.5,4,4.9,4S35.4,28.3,35.9,26z M6,2h3v7.7H2V6C2,3.8,3.8,2,6,2z M2,23
			V11.7h25c0.3,2.4,2.4,4.3,4.9,4.3h6v7c0,0.5-0.5,1-1,1h-1.1c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H13.9c-0.5-2.3-2.5-4-4.9-4
			c-2.4,0-4.4,1.7-4.9,4H3C2.5,24,2,23.5,2,23z M27,2v7.7h-7V2H27z M18,2v7.7h-7V2H18z M29,2h5c2.2,0,4,1.8,4,4v8h-6
			c-1.7,0-3-1.3-3-3V2z M9,22c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3C6,23.3,7.3,22,9,22z M28,25c0-1.7,1.3-3,3-3
			s3,1.3,3,3c0,1.7-1.3,3-3,3S28,26.7,28,25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Bus2
};
